import { AxiosResponse } from 'axios'
import { IAuthContext, IAuthCreatePassword, IAuthForgotPass, IAuthLogin, IAuthRecoveryCode, IAuthResetPassword, IMessage } from '@interfaces/index'
import api from '@services/api/server'

export default class AuthService {
    public static async login(data: IAuthLogin): Promise<IAuthContext> {
        return (await api.post<IAuthContext>('/users/login', data)).data
    }

    public static async emailConfirmation(data: IAuthForgotPass): Promise<IMessage> {
        return (await api.post<IMessage>('/users/request-reset-password', data)).data
    }

    public static async sendRecoveryCode(data: IAuthRecoveryCode): Promise<IMessage> {
        return (await api.post<IMessage>('/users/verify-reset-password', data)).data
    }

    public static async sendResetPassword(data: IAuthResetPassword): Promise<IMessage> {
        return (await api.put<IMessage>('/users/reset-password', data)).data
    }

    public static async refreshToken(refreshToken: string): Promise<AxiosResponse> {
        return await api.post<AxiosResponse>('/users/refresh-token', { refreshToken })
    }

    public static async createPassword(data: IAuthCreatePassword, token: string, userId: number): Promise<AxiosResponse> {
        return await api.put<AxiosResponse>(`/users/${userId}/create-password?token=${token}`, data)
    }
}
